import { DownloadIcon } from "@chakra-ui/icons";
import { Link } from "@chakra-ui/react";
import { FC } from "react";

import { downloadFile } from "@nens/shared-utils";

interface DownloadIconLinkProps {
  filename: string;
  fetchUrl: () => Promise<string | undefined>;
}

export const DownloadIconLink: FC<DownloadIconLinkProps> = ({ filename, fetchUrl }) => {
  return (
    <Link
      href="#"
      onClick={async (event) => {
        event.preventDefault();
        const url = await fetchUrl();
        if (url) {
          downloadFile(url, filename || "");
        }
      }}
    >
      <DownloadIcon boxSize={4} color="brand.sky" />
    </Link>
  );
};
